import { useEffect, useState, useMemo } from "react";
import { Col, Descriptions, DescriptionsProps, Form, Row } from "antd";
import { userString } from "config/site.string";
import { loadState } from "library/helpers/sessionStorage";
import { useUserAssignedCustomers } from "components/hooks/useUserAssignedCustomers";
// import { useUserAssignedVendors } from "components/hooks/useUserAssignedVendors";
import { AccountSettingsWrapper, LabelDisplay } from "../styles";

interface Permission {
  id: number;
  section: string;
}

interface SelectedRecord {
  accountId: string;
  email: string;
  firstName: string;
  lastName: string;
  customers: any;
  vendors: any;
}

interface AccountSettingsProps {
  form: any;
  isAccount: boolean;
  selectedRecord: SelectedRecord;
}

const PermissionDisplay = ({ permissions }: any) => {
  const { view, edit } = permissions.actions;

  return (
    <div style={{ display: "flex", marginTop: 5 }}>
      <LabelDisplay>{permissions.label}</LabelDisplay>
      <div style={{ color: "#000000", fontFamily: "Poppins" }}>
        &nbsp;(
        {edit ? "Edit" : view ? "View" : ""})
      </div>
    </div>
  );
};

const AccountSettings: React.FC<AccountSettingsProps> = ({
  form,
  selectedRecord,
}) => {
  const [permissions, setPermissions] = useState<any>([]);

  // Use custom hooks to get filtered customers and vendors
  const { filteredCustomers } = useUserAssignedCustomers();
//   const { filteredVendors } = useUserAssignedVendors();
  const permissionTypes = loadState("actualPermissionsList") as Permission[];

  // Transform filtered data for display
  const transformedCustomers = useMemo(
    () =>
      filteredCustomers.map((customer: any) => ({
        label: customer.companyName,
        code: customer.companyCode,
      })),
    [filteredCustomers]
  );

//   const transformedVendors = useMemo(
//     () =>
//       filteredVendors.map((vendor: any) => ({
//         label: vendor.vendorName,
//         code: vendor.vendorId,
//       })),
//     [filteredVendors]
//   );

  useEffect(() => {
    setPermissions(permissionTypes);
  }, [permissionTypes]);

  const handleSubmit = (values: any) => {
    console.log("values", values);
  };

  const items: DescriptionsProps["items"] = [
    {
      key: "1",
      label: <>{userString.email}</>,
      children: <p>{selectedRecord.email}</p>,
      span: 4,
    },
    {
      key: "2",
      label: <>{userString.firstName}</>,
      children: <p>{selectedRecord.firstName}</p>,
      span: 4,
    },
    {
      key: "3",
      label: <>{userString.lastName}</>,
      children: <p>{selectedRecord.lastName}</p>,
      span: 4,
    },
    {
      key: "4",
      label: <>{`${userString.orderEntryCustomer}(s)`}</>,
      children: (
        <div>
          {transformedCustomers?.map((item: any, index: number) => {
            return <LabelDisplay key={index}>{item.label}</LabelDisplay>;
          })}
        </div>
      ),
      span: 4,
    },
    // {
    //   key: "5",
    //   label: <>{`${userString.invoiceCustomer}(s)`}</>,
    //   children: (
    //     <div>
    //       {transformedVendors?.map((item: any, index: number) => {
    //         return <LabelDisplay key={index}>{item.label}</LabelDisplay>;
    //       })}
    //     </div>
    //   ),
    //   span: 4,
    // },
    {
      key: "6",
      label: <>Permissions</>,
      children: (
        <div>
          {permissions?.map((item: any, index: number) => {
            return <PermissionDisplay key={index} permissions={item} />;
          })}
        </div>
      ),
      span: 4,
    },
  ];

  return (
    <AccountSettingsWrapper>
      <Form
        form={form}
        name="user"
        layout="horizontal"
        style={{ padding: "12px 20px 0px" }}
        onFinish={handleSubmit}
        id="accountSettings"
        labelCol={{ span: 10 }}
        className="account-setting-form"
      >
        <Row gutter={24}>
          <Col span={24}>
            <Descriptions bordered items={items} />
          </Col>
        </Row>
      </Form>
    </AccountSettingsWrapper>
  );
};

export default AccountSettings;
